import { IMenuDetails, EMenuState } from "./usePopoverMenuStore.types";

export const INITIAL_STATE: IMenuDetails = {
  state: EMenuState.CLOSED,
  title: "",
  items: [],
};
